export default __webpack_public_path__ + "static/Sizzle_New_Desktop-a3125acf8093147f6d8f12da799606a2.mp4";